var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85762 13.2755L13.1432 6.98995M4.49985 9.34661L2.92873 10.9177C2.51602 11.3304 2.18863 11.8204 1.96527 12.3596C1.74191 12.8989 1.62695 13.4768 1.62695 14.0605C1.62695 14.6442 1.74191 15.2221 1.96527 15.7614C2.18863 16.3006 2.51602 16.7906 2.92873 17.2033C3.34145 17.616 3.83141 17.9434 4.37065 18.1667C4.90989 18.3901 5.48784 18.5051 6.07151 18.5051C6.65518 18.5051 7.23313 18.3901 7.77237 18.1667C8.31161 17.9434 8.80157 17.616 9.21429 17.2033L10.7832 15.6322M9.21318 4.63217L10.7843 3.06106C11.197 2.64834 11.687 2.32096 12.2262 2.0976C12.7654 1.87424 13.3434 1.75928 13.9271 1.75928C14.5107 1.75928 15.0887 1.87424 15.6279 2.0976C16.1672 2.32096 16.6571 2.64834 17.0698 3.06106C17.4826 3.47377 17.8099 3.96374 18.0333 4.50298C18.2567 5.04222 18.3716 5.62017 18.3716 6.20384C18.3716 6.7875 18.2567 7.36546 18.0333 7.9047C17.8099 8.44393 17.4826 8.9339 17.0698 9.34661L15.4987 10.9177",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSelect);
export default __webpack_public_path__ + "static/media/fileSelect.aef11b1858750c00eb76d7faa880fb7c.svg";
export { ForwardRef as ReactComponent };